import { render, staticRenderFns } from "./studentSelectDialog.vue?vue&type=template&id=0a155a9e&scoped=true&"
import script from "./studentSelectDialog.vue?vue&type=script&lang=ts&"
export * from "./studentSelectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./studentSelectDialog.vue?vue&type=style&index=0&id=0a155a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a155a9e",
  null
  
)

export default component.exports